import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout/Layout';
import Home from './pages/Home';
import AllGames from './pages/AllGames';
import GameDetail from './pages/GameDetail';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import AdminPanel from './pages/AdminPanel';
import News from './pages/News';
import About from './pages/About';
import Privacy from './pages/Privacy';
import Imprint from './pages/Imprint';
import EmailConfirmation from './pages/EmailConfirmation';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Shop from './pages/Shop';
import AdminGameDetail from './pages/AdminGameDetail';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/registrieren" element={<Register />} />
              <Route path="/datenschutz" element={<Privacy />} />
              <Route path="/impressum" element={<Imprint />} />
              <Route path="/email-bestaetigung/:token" element={<EmailConfirmation />} />
              <Route path="/passwort-vergessen" element={<ForgotPassword />} />
              <Route path="/passwort-zuruecksetzen/:token" element={<ResetPassword />} />

              {/* Geschützte Routen - nur für eingeloggte User */}
              <Route path="/spiele" element={
                <ProtectedRoute>
                  <AllGames />
                </ProtectedRoute>
              } />
              <Route path="/shop" element={
                <ProtectedRoute>
                  <Shop />
                </ProtectedRoute>
              } />
              <Route path="/spiel/:id" element={
                <ProtectedRoute>
                  <GameDetail />
                </ProtectedRoute>
              } />
              <Route path="/news" element={
                <ProtectedRoute>
                  <News />
                </ProtectedRoute>
              } />
              <Route path="/ueber-uns" element={
                <ProtectedRoute>
                  <About />
                </ProtectedRoute>
              } />
              <Route path="/profil" element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute adminOnly={true}>
                  <AdminPanel />
                </ProtectedRoute>
              } />
              <Route path="/admin/spiel/:id" element={
                <ProtectedRoute adminOnly={true}>
                  <AdminGameDetail />
                </ProtectedRoute>
              } />
            </Routes>
          </Layout>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
